module.exports = __webpack_public_path__ + "assets/img/4old.8f2f649a.png";